module.exports = __webpack_public_path__ + "img/reiniciar.7de9eba7.png";